import { useState } from 'react';
import Modal from './Modal';
import { sendFeedback } from '../api/client';
import './FeedbackModal.css';

export default function FeedbackModal({ onClose }) {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!subject.trim() || !message.trim()) {
      setError('Please fill in both the subject and message.');
      return;
    }
    setSending(true);
    setError('');
    try {
      await sendFeedback({ subject: subject.trim(), message: message.trim() });
      setSent(true);
    } catch (err) {
      setError(err.message || 'Failed to send feedback');
    } finally {
      setSending(false);
    }
  }

  if (sent) {
    return (
      <Modal title="Feedback" onClose={onClose}>
        <p className="feedback-modal-text">Thanks for the feedback — we've received it.</p>
        <div className="feedback-modal-actions">
          <button className="feedback-btn-primary" onClick={onClose}>
            Done
          </button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal title="Feedback" onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <label className="feedback-field">
          <span>Subject</span>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            maxLength={200}
            disabled={sending}
            autoFocus
          />
        </label>
        <label className="feedback-field">
          <span>Message</span>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={6}
            maxLength={5000}
            disabled={sending}
          />
        </label>

        {error && <p className="feedback-modal-error">{error}</p>}

        <div className="feedback-modal-actions">
          <button type="button" className="feedback-btn-secondary" onClick={onClose} disabled={sending}>
            Cancel
          </button>
          <button type="submit" className="feedback-btn-primary" disabled={sending}>
            {sending ? 'Sending…' : 'Send feedback'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
